module.exports = ".user-avatar {\n  margin-left: 0px !important;\n  margin-top: 0px !important;\n  width: auto !important;\n  height: 300px !important;\n}\n\n.seal {\n  background: url(https://d2zmbkdpl0cf9q.cloudfront.net/../assets/icons/seal.svg) center center no-repeat;\n  width: 165px;\n  height: 165px;\n}\n\n.no-margin {\n  margin: 0px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = ./src/app/dashboard/dashboard.component.css
// module chunks = main